export const tableConstants = {
    NAME_WIDTH: 'w-25',
    DATE_RANGE_WIDTH: 'w-30',
    SMALL_GRID_NAME_WIDTH: 'w-30',
    DEFAULT_WIDTH: 'w-15',
    CHECKBOX_WIDTH: 'w-5',
    ACTION_WIDTH: 'w-5',
    CALL_NAME_WIDTH: 'w-20table',
    USER_WIDTH: 'w-25rem'
}